import {getRequest, URL_SERVER} from './../requests'


export async function getMyShops(token){
    try {
        return await getRequest(URL_SERVER + '/myshops', token)
    } catch (error) {
        console.error(error);
    }
}